import { BaseMapper } from '@/core/mapper';

import { Location } from '@/core/location';
import { Vendor } from '@/core/vendor';

const schema = {
  uuid: {
    parseFrom: 'attributes.uuid',
  },
  token: {
    parseFrom: 'attributes.token',
  },
  induction_url: {
    parseFrom: 'attributes.induction_url',
  },
  name: {
    parseFrom: 'relationships.induction.attributes.name',
    omitFromRequest: true,
  },
  clients: {
    fromResponse: (entity) => {
      const workerComplianceRequirements = _.get(entity, 'relationships.worker_compliance_requirements.data');
      return (workerComplianceRequirements || [])
        .map((wcr) => {
          const client = _.get(wcr, 'relationships.client.data');
          return client && new Vendor(client);
        })
        // filter out undefined client from the list
        .filter(client => !!client);
    },
    omitFromRequest: true,
  },
  locations: {
    fromResponse: (entity) => {
      const workerComplianceRequirements = _.get(entity, 'relationships.worker_compliance_requirements.data');
      return (workerComplianceRequirements || [])
        .map((wcr) => {
          const location = _.get(wcr, 'relationships.location');
          return location && new Location(location);
        })
        // filter out undefined location from the list
        .filter(location => !!location);
    },
    omitFromRequest: true,
  },
  current_status: {
    parseFrom: 'meta.current_status',
    omitFromRequest: true,
  },
  expiry_date: {
    parseFrom: 'attributes.expiry_date',
    omitFromRequest: true,
  },
  expiry_period: {
    parseFrom: 'relationships.induction_version.attributes.expiry_period',
    omitFromRequest: true,
  },
};

class WorkerInduction extends BaseMapper {
  constructor(entity = null) {
    super({ entity, schema });
  }
}

WorkerInduction.schema = schema;

export default WorkerInduction;
